package com.cybersoftsolution.cybersoftsolutionweb.components.dialogs

import androidx.compose.runtime.Composable
import com.cybersoftsolution.cybersoftsolutionweb.models.Theme
import com.cybersoftsolution.cybersoftsolutionweb.pages.admin.Device.isDesktop
import com.cybersoftsolution.cybersoftsolutionweb.utils.Resources
import com.varabyte.kobweb.compose.css.FontStyle
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.css.TransitionProperty
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontStyle
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.textAlign
import com.varabyte.kobweb.compose.ui.modifiers.transition
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.text.SpanText
import org.jetbrains.compose.web.css.ms
import org.jetbrains.compose.web.css.px


@Composable
fun FooterSectionDialog() {
    Column(
        verticalArrangement = Arrangement.Center,
        horizontalAlignment = Alignment.CenterHorizontally,
        modifier = Modifier
            .fillMaxWidth()
            .padding(bottom = 20.px)
    ) {
        Image(
            modifier = Modifier
                .transition(Transition.of(property = TransitionProperty.All, duration = 300.ms))
                .width(if (isDesktop()) 80.px else 60.px),
            src = Resources.Images.icoLogo,
            alt = "Ico",
        )

        SpanText(
            modifier = Modifier
                .fontSize(13.px)
                .fillMaxWidth()
                .textAlign(TextAlign.Center)
                .color(Theme.HalfBlack.rgb)
                .fontStyle(FontStyle.Normal),
            text = "Copyright © 2025 Cyber Soft Solution"
        )
        SpanText(
            modifier = Modifier
                .fontSize(13.px)
                .fillMaxWidth()
                .textAlign(TextAlign.Center)
                .color(Theme.HalfBlack.rgb)
                .fontStyle(FontStyle.Normal),
            text = "Todos los derechos reservados"
        )


    }
}